var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DateTimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
var DateTimePickerWithTimeZone = function (_a) {
    var defaultValue = _a.value, onChange = _a.onChange, renderInput = _a.renderInput, props = __rest(_a, ["value", "onChange", "renderInput"]);
    var _b = React.useState(defaultValue), value = _b[0], setValue = _b[1];
    var _c = React.useState(false), accepted = _c[0], setAccepted = _c[1];
    React.useEffect(function () {
        setValue(defaultValue);
    }, [defaultValue]);
    var handleAccept = React.useCallback(function (date) {
        if (defaultValue instanceof Date &&
            date instanceof Date &&
            defaultValue.getTime() === date.getTime()) {
            return;
        }
        if (defaultValue === date)
            return;
        setAccepted(true);
        onChange(date);
    }, [defaultValue, onChange]);
    var handleClose = React.useCallback(function () {
        if (!accepted)
            setValue(defaultValue);
        setAccepted(false);
    }, [accepted, defaultValue]);
    var defaultRenderInput = React.useCallback(function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { fullWidth: true, margin: "normal", variant: "outlined" }))); }, []);
    return (React.createElement(DateTimePicker, __assign({ inputFormat: "yyyy-MM-dd HH:mm (zzzz)", ampm: false, views: ['day', 'hours'], value: value, onChange: setValue, onAccept: handleAccept, onClose: handleClose, minutesStep: 60, renderInput: renderInput || defaultRenderInput, PopperProps: {
            keepMounted: false,
        } }, props)));
};
export default DateTimePickerWithTimeZone;
